import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';

import { useSelector } from 'react-redux';
import { Card, Row } from 'react-bootstrap';
import QRCode from '../../assets/qr-code.svg';
import InformationBooking from './components/InformationBooking';
import IconPerson from '../../assets/new-icons/icon-min.png';
import usePageNavigation from '../../hooks/usePageNavigation';

function FinishedPage() {
  const { guestList } = useSelector((state) => state.guests);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { navigateNextPage } = usePageNavigation();

  const goTo = () => {
    navigateNextPage('');
    // navigate('/'); // Navega a la ruta "/about"
  };

  return (
    <div className="checking__important-remember d-flex flex-column h-100">
      <div className="text-center mb-3">
        <p className="my-3 app-fs-h4 app-lh-h4 app-txt-granite app-fw-notosans-bold">{t('TXT_REGISTRATION_DETAIL')}</p>
      </div>
      {/* <p className="mb-1 app-txt-granite-80-dark app-txt-notosans-bold app-fs-14 text-center">
        Hemos enviado a tu correo el contrato de tu estancia. Presenta éste QR en recepción para recibir tu llave.
      </p> */}

      {/* <div className="text-center">
        <img className="img-fluid" src={QRCode} alt="qr code" style={{ height: '150px' }} />
      </div> */}

      <InformationBooking />

      {/* <div className="hr-gold my-3" /> */}

      <div className="guest-list mt-4">
        {guestList.map((item) => (
          <Card key={item.IDHuesped} className="border-solid-1 transition-border-color border-granite-80-light mb-2">
              <Card.Body>
                <Row>
                  <div className="d-flex">
                    <div className="guest my-auto pe-3">
                      <img src={IconPerson} alt="iconPerson" className="img-fluid-33" />
                    </div>
                    <div className="flex-fill">
                      <p className="mb-1 app-fs-15 app-txt-granite-80 app-fw-notosans-bold">{item.Nombre}</p>
                      <p className="mb-0 app-fs-14 app-txt-granite-80-dark">{t(`TXT_GUEST_${item.TipoPersona}`)}</p>
                    </div>
                  </div>
                </Row>
              </Card.Body>
          </Card>
        ))}
      </div>

      <div className="d-flex flex-grow-1 align-items-end pb-2">
        <Button
          variant=""
          className="app-bg-sand app-fw-notosans-bold app-txt-granite w-100 rounded-3 btn-height border-0"
          onClick={goTo}
        >
          {t('TXT_BOTON_END')}
        </Button>
      </div>
    </div>
  );
}

export default FinishedPage;
